/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ model: NonNullable<unknown> }} Video_Credit_Trial_Apply_ModelInputs */

const en_video_credit_trial_apply_model = /** @type {(inputs: Video_Credit_Trial_Apply_ModelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Use ${i?.model} · 480p · 4s`)
};

const es_video_credit_trial_apply_model = /** @type {(inputs: Video_Credit_Trial_Apply_ModelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Usar ${i?.model} · 480p · 4 s`)
};

/**
* | output |
* | --- |
* | "Use {model} · 480p · 4s" |
*
* @param {Video_Credit_Trial_Apply_ModelInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const video_credit_trial_apply_model = /** @type {((inputs: Video_Credit_Trial_Apply_ModelInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Credit_Trial_Apply_ModelInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_video_credit_trial_apply_model(inputs)
	return es_video_credit_trial_apply_model(inputs)
});